import InputField from "./InputField";


export class Textarea extends InputField{
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={this.props.Columns}>
                <div className="field text">
                    <label className="" htmlFor={this.props.id}>
                        {this.renderLabelText()}
                    </label>
                    <textarea id={this.props.id} rows="6" className="text form-control" value={this.props.value} placeholder={this.props.Placeholder} required={this.props.Required} onChange={(e) => {this.props.collectData(this.props.id, e.target.value)}} />
                    {this.renderErrorMessage()}
                </div>
            </div>
        )
    }
}
